"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Compass, KeyRound, UserRound } from "lucide-react";
import { cn } from "@/lib/cn";
import { LangProvider, useLang } from "./lang";

export function GuestHeader() {
  return (
    <header className="sticky top-0 z-30 pointer-events-none px-4 pt-[max(0.75rem,env(safe-area-inset-top))] pb-3 backdrop-blur-xl bg-[color-mix(in_srgb,var(--paper)_78%,transparent)]">
      <div className="pointer-events-auto max-w-lg mx-auto flex items-end justify-between">
        <Link href="/" className="display text-[1.65rem] leading-none">
          Lantern
        </Link>
        <span className="text-[11px] tracking-[0.18em] uppercase text-muted">Philadelphia</span>
      </div>
    </header>
  );
}

export function BottomNav() {
  const path = usePathname();
  const { t } = useLang();
  const items = [
    { href: "/", label: t("navExplore"), icon: Compass, match: (p: string) => p === "/" || p.startsWith("/stay") || p.startsWith("/book") },
    { href: "/my-stay", label: t("navStay"), icon: KeyRound, match: (p: string) => p.startsWith("/my-stay") },
    { href: "/me", label: t("navMe"), icon: UserRound, match: (p: string) => p.startsWith("/me") || p.startsWith("/login") },
  ];
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 pointer-events-none border-t bg-[color-mix(in_srgb,var(--paper)_88%,transparent)] backdrop-blur-xl pb-[var(--safe-bottom)]">
      <div className="pointer-events-auto max-w-lg mx-auto grid grid-cols-3">
        {items.map((item) => {
          const active = item.match(path);
          const Icon = item.icon;
          return (
            <Link
              key={item.href}
              href={item.href}
              className={cn("flex flex-col items-center gap-1 py-3 text-xs", active ? "text-clay" : "text-muted")}
            >
              <Icon size={20} strokeWidth={active ? 2.4 : 1.8} />
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export function GuestShell({ children }: { children: React.ReactNode }) {
  return (
    <LangProvider>
      <div className="min-h-dvh flex flex-col">
        <GuestHeader />
        <main className="relative z-10 flex-1 w-full max-w-lg mx-auto pb-28">{children}</main>
        <BottomNav />
      </div>
    </LangProvider>
  );
}
